// extracted by mini-css-extract-plugin
export var container = "_m8-0";
export var dotAnimation = "_m8-2";
export var dotsLoading = "_m8-1";